import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SlickConfirmDialogModule, SlickContainerModule } from "@slick-components";
import { OrendaModule } from "@components/orenda";
import { EquipmentTrackingModule } from "@shared-components/equipment-tracking/equipment-tracking.module";
import { ReadingsAndDosagesDialogModule } from "@app/appointments/components/readings-and-dosages-dialog/readings-and-dosages-dialog.module";
import { AssetsComponent } from "./assets.component";
import { AssetsReadingsAndDosagesComponent } from "./assets-readings-and-dosages.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SlickConfirmDialogModule,
		SlickContainerModule,
		OrendaModule,
		EquipmentTrackingModule,
		ReadingsAndDosagesDialogModule
	],
	declarations: [
		AssetsComponent,
		AssetsReadingsAndDosagesComponent
	],
	exports: [
		AssetsComponent,
		AssetsReadingsAndDosagesComponent
	]
})
export class AssetsModule { }
